import React from "react";
import { Container } from "semantic-ui-react";
import PresentationListItem from "./PresentationListItem";

export default function PresentationList({ cards }) {
  return (
    <Container>
      {cards.map((card) => (
        <PresentationListItem card={card} key={card.id} />
      ))}
    </Container>
  );
}
